<div class="relative" (keydown.escape)="isOpen.set(false)">
  <button
    type="button"
    class="context-selector__button"
    aria-haspopup="listbox"
    [attr.aria-expanded]="isOpen()"
    (click)="toggleOpen()"
  >
    <span class="context-selector__badge context-selector__badge--brand" aria-hidden="true">
      <mtm-icon name="sparkles" [size]="14" />
    </span>
    <span class="context-selector__text">
      <span class="context-selector__title">{{ 'SIDEBAR.SUBSCRIPTION' | translate }}</span>
      <span class="context-selector__value">{{
        selected()?.subscriptionName ?? ('SIDEBAR.SELECT_SUBSCRIPTION' | translate)
      }}</span>
    </span>
    <mtm-icon class="context-selector__chevron" name="chevrons-up-down" [size]="14" />
  </button>

  @if (isOpen()) {
    <ul
      class="context-selector__list"
      role="list"
      [attr.aria-label]="'SIDEBAR.SELECT_SUBSCRIPTION' | translate"
    >
      @for (sub of options(); track sub.subscriptionUuid) {
        <li role="listitem">
          <button type="button" class="context-selector__item" (click)="onSelect(sub)">
            <span class="flex items-center gap-2">
              <span class="clamp-2 text-sm">{{ sub.subscriptionName }}</span>
            </span>
          </button>
        </li>
      } @empty {
        <li role="listitem">
          <span class="context-selector__empty">{{ 'SIDEBAR.NO_SUBSCRIPTIONS' | translate }}</span>
        </li>
      }
    </ul>
  }
</div>
